import { render } from "./DatepickerContent.vue?vue&type=template&id=884788f2"
import script from "./DatepickerContent.vue?vue&type=script&lang=js"
export * from "./DatepickerContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__